export const tabs = [
  {title: 'Overview', value: 'overview'},
  {title: 'Ownership History', value: 'history'},
]

export const TIMELINE = "timeline";
export const TABLE = "table";

export const historyTabs = [
  {title: 'Timeline', value: TIMELINE},
  {title: 'Table', value: TABLE},
]

export const timelineData = [
  {
    id: 1,
    name: "Rohit Bisht",
    from: "04-01-2025",
    to: "Present",
    isActive: true, // Highlights the ring border in blue
  },
  {
    id: 2,
    name: "Meena Khatun",
    from: "04-01-2024",
    to: "04-01-2025",
    isActive: false,
  },
  {
    id: 3,
    name: "Shivam Dubey",
    from: "04-01-2023",
    to: "04-01-2024",
    isActive: false,
  },
];